const LABELS = {
  en: {
    presentation: "Presentation",
    experiences: "Experiences",
    roles: "Roles",
    skills: "Skills",
    languages: "Languages",
    hobbies: "Hobbies",
    education: "Education",
    tools: "Tools",
    present: "Present",
    missingDate: "Missing Date",
    anonymous: "Anonymous",
    managerContactInfo: "Consultant Manager contact info:",
    noName: "No name...",
    noEmail: "No email...",
    noPhone: "No phone...",
    noLocation: "No location...",
    noPresentation: "No presentation...",
    noExperiences: "No experiences...",
    noRoles: "No Role...",
    noSkills: "No skills...",
    noLanguages: "No languages...",
    noHobbies: "No hobbies...",
    noEducations: "No education...",
  },
  sv: {
    presentation: "Presentation",
    experiences: "Erfarenheter",
    roles: "Roller",
    skills: "Kompetenser",
    languages: "Språk",
    hobbies: "Intressen",
    education: "Utbildning",
    tools: "Verktyg",
    present: "Pågående",
    missingDate: "Datum saknas",
    anonymous: "Anonym",
    managerContactInfo: "Kontaktuppgifter till konsultchef:",
    noName: "Inget namn...",
    noEmail: "Ingen e-post...",
    noPhone: "Ingen telefon...",
    noLocation: "Ingen ort...",
    noPresentation: "Ingen presentation...",
    noExperiences: "Inga erfarenheter...",
    noRoles: "Ingen roll...",
    noSkills: "Inga kompetenser...",
    noLanguages: "Inga språk...",
    noHobbies: "Inga intressen...",
    noEducations: "Ingen utbildning...",
  },
};

const getProfileLabel = (language, key) => {
  const labels = LABELS[language] || LABELS.en;
  return labels[key] !== undefined ? labels[key] : LABELS.en[key];
};

export default getProfileLabel;
